// import { isEmpty } from 'lodash-es';
import React, { useEffect, useState } from 'react';
import { RouteConfig } from 'react-router-config';
import { Redirect, Route, Switch } from 'react-router-dom';
import { isInternal, isWOA } from '@/infrastructure/auth';
import { getParamFromUrl } from '@/infrastructure/history';
// import { storageGet } from '@/infrastructure/storage-utils';
import { getIssueDetailUrl } from '@/infrastructure/utils/issue';
import { Loading } from '@/presentation/components/loading';
import { useAuthContext } from '@/presentation/hooks';
import { stores } from '@/presentation/store';

export const RedirectRoute = () => {
  const productId = getParamFromUrl('productId');
  const pid = getParamFromUrl('pid');
  const { authInfo } = useAuthContext();

  const RedirectIssue = (props: any) => {
    const { exceptionType, appId, feature } = props.match.params;
    const search = window.location.search.slice(1);
    const issueDetailUrl = getIssueDetailUrl(exceptionType);
    const [init, setInit] = useState(false);

    useEffect(() => {
      const load = async () => {
        await stores.ProductStore.loadProducts();
        await stores.ProductStore.setId(appId);
        setInit(true);
      };
      load();
    }, []);

    if (!init) {
      return <Loading />;
    }
    return <Redirect to={`${issueDetailUrl}?productId=${appId}&pid=${pid}&feature=${feature}&${search}`} />;
  };

  const RedirectAll = () => {
    // 如果没登录，不处理，走登录跳转逻辑
    if (isInternal() && !authInfo?.isLoggedIn) {
      return null;
    }

    return <Redirect to={'/'}/>;
  };

  const getExtParams = () => {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.delete('pid');

    return searchParams.toString();
  };

  // 兼容不带productId参数的链接
  const createRenderFunc = (basePath: string): any => {
    const pid = getParamFromUrl('pid');

    const RedirectComponent = (props: any) => {
      const { appId } = props.match.params;
      const [init, setInit] = useState(false);

      useEffect(() => {
        const load = async () => {
          await stores.ProductStore.loadProducts();
          await stores.ProductStore.setId(appId);
          setInit(true);
        };
        load();
      }, []);

      if (!init) {
        return <Loading />;
      }
      return <Redirect to={`${basePath}?productId=${appId}&pid=${pid}&${getExtParams()}`} />;
    };

    return RedirectComponent;
  };

  return <Switch>
    {/* 详情页 */}
    <Route path={'/:version?/crash-reporting/:exceptionType/:appId/:feature/report'} component={RedirectIssue}/>
    {/* 异常分析 */}
    <Route path={'/:version?/crash-reporting/dashboard/:appId'} component={createRenderFunc('/exception/crash/dashboard')} />
    <Redirect from={'/:version?/crash-reporting/crashes/:appId'} to={`/exception/crash/issues/list?productId=${productId}&pid=${pid}&${getExtParams()}`}/>
    <Redirect from={'/:version?/crash-reporting/errors/:appId'} to={`/exception/error/issues/list?productId=${productId}&pid=${pid}&${getExtParams()}`}/>
    <Redirect from={'/:version?/crash-reporting/blocks/:appId'} to={`/exception/anr/issues/list?productId=${productId}&pid=${pid}&${getExtParams()}`}/>
    <Redirect from={'/:version?/ftanalyse/apps/:appId'} to={`/exception/crash/ft?productId=${productId}&pid=${pid}`}/>
    <Redirect from={'/:version?/keyword-summary/apps/:appId'} to={`/exception/crash/keyword?productId=${productId}&pid=${pid}`}/>
    {/* 设置 */}
    <Redirect from={'/:version?/crash-reporting/preferences/notification/:appId'} to={`/setting/crash-alert?productId=${productId}&pid=${pid}`}/>
    <Redirect from={'/:version?/crash-reporting/preferences/tags/:appId'} to={`/setting/tag?productId=${productId}&pid=${pid}`}/>
    <Redirect from={'/:version?/crash-reporting/preferences/dsyms/:appId'} to={`/setting/dsyms?productId=${productId}&pid=${pid}`}/>
    <Redirect from={'/:version?/crash-reporting/preferences/tapd/:appId'} to={`/setting/tapd?productId=${productId}&pid=${pid}`}/>
    <Redirect from={'/:version?/setting/tapd-auth'} to={`/setting/tapd?productId=${getParamFromUrl('state')}&state=${getParamFromUrl('state')}`}/>
    <Redirect from={'/:version?/ftmgr/apps/:appId'} to={`/setting/ft?productId=${productId}&pid=${pid}`}/>
    <Redirect from={'/:version?/keyword-setting/apps/:appId'} to={`/setting/keyword?productId=${productId}&pid=${pid}`}/>
    <Redirect from={'/:version?/product/apps/:appId'} to={`/setting/product?productId=${productId}&pid=${pid}`}/>
    <Redirect from={'/:version?/v2/setting/alert'} to={`/setting/alert?productId=${productId}&pid=${pid}`}/>
    {/* 产品 */}
    <Redirect from={'/:version?/workbench/apps'} to={'/workbench/apps'}/>
    <Redirect from={'/:version?/workbench/createoa/:name'} to={'/workbench/register'}/>
    {/* RMonitor */}
    <Redirect from={'/:version?/drop-frame/anr/list'} to={`/exception/anr/issues/list${location.search}`}/>
    <Redirect from={'/:version?/drop-frame/anr/detail'} to={`/exception/anr/issues/detail${location.search}`}/>
    <Redirect from={'/:version?/memory/foom/list'} to={`/exception/foom/issues/list${location.search}`}/>
    <Redirect from={'/:version?/memory/foom/detail'} to={`/exception/foom/issues/detail${location.search}`}/>
    <Redirect from={'/:version?/memory/foom/detail'} to={`/exception/foom/issues/detail${location.search}`}/>
    {/* 合规入口页 */}
    <Redirect from={'/compliance/issues/entry'} to={`/entry${location.search}&route=%2Fcompliance%2Fissues%2Flist&backTime=500&filterSceneProblem=是`}/>
    {/* 兜底 */}
    <Route component={RedirectAll}/>
  </Switch>;
};

export const redirectRoute = (): RouteConfig[] => {
  if (!isWOA() && !isInternal()) {
    return [];
  }

  return [
    {
      path: '/',
      hideInMenu: true,
      sort: 9,
      render: () => <RedirectRoute />,
    },
  ];
};

export default redirectRoute;
